export default function Logout() {
  localStorage.removeItem('refreshToken');
  window.location.href = '/login';
  return <></>;
}